import { FC } from 'react';
import { useQuery } from 'react-query';

import { Button, VText } from '@vake/ui-kit';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { getRequestHeaders, vake_api_server_url } from '../requests/helpers';
import { Loading } from './loading/loading';

export interface Site {
    title: string;
    url: string;
    text: string;
}

const useGetAllSites = () => {
    const { token } = useAuth();
    const url = `${vake_api_server_url}/admin/get-admin-sites`;
    return useQuery<Site[]>(['admin_sites'], async () => {
        const res = await fetch(url, {
            credentials: 'include',
            headers: getRequestHeaders(token),
        });

        if (!res.ok) {
            throw new Error(res.statusText);
        }

        return await res.json();
    });
};

export const GridPageDisplay: FC<{ websites: Site[] }> = ({ websites }) => {
    return (
        <div className="grid grid-cols-4 gap-1">
            {websites &&
                websites.map((site, i) => {
                    return (
                        <div className="flex flex-col items-center text-center p-2" key={i}>
                            <Link to={site.url}>
                                <Button variant="primary" text={site.title} size="medium"></Button>
                            </Link>
                            <VText variant="B1">{site.text}</VText>
                        </div>
                    );
                })}
        </div>
    );
};

const Admin: FC = () => {
    const { data: adminSites, isLoading, isError } = useGetAllSites();

    if (isLoading) {
        return <Loading></Loading>;
    }
    if (isError) {
        return (
            <div className="flex items-center justify-center h-screen w-fill bg-background-primary">
                <VText>Fetching data failed</VText>
            </div>
        );
    }
    return (
        <div className="flex items-center justify-center h-screen w-fill bg-background-primary">
            {typeof adminSites !== 'undefined' ? <GridPageDisplay websites={adminSites} /> : null}
        </div>
    );
};

export default Admin;
